import { observable, action } from "mobx";
import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import { status, paymentStatus, recordStatus, SUBJECT_DATA } from "../dummy/stauts";
import { DataService } from '../services/data.service';
import { AdministratorService } from '../services/administrator.service';
import { attendancePolicyObj, MappingService, pageKey, pushToArray, pushToObject, attendantRemarkObj, studentObj, toDateKey, toMonthKey, userObj } from 'src/app/shared/services/mapping.service';
import { ConvertService, toHourMM, toTimeHourMMA } from 'src/app/shared/services/convert.service';
import { IStudentAccount } from '../interfaces/student';
import * as firebase from 'firebase/app';
import { Observable, of, Subscription } from "rxjs";
import { distinct } from "rxjs/operators";
import { AngularFirestore } from "@angular/fire/firestore";
import { Pages } from "../dummy/pages";
import * as moment from "moment";
import { ATTENDANCE_MOVEMENT_SOURCE, CREATE_TIME_TYPE, HR_USER_TYPES } from "../dummy/config";
import { AuthStore } from "./auth.store";
import { ATTENDANCE_TYPE } from "../dummy/app";
import { deleteData, deleteTimeAtt } from "./sudentDeleteData";


@Injectable({ providedIn: 'root' })
export class StudentStore {
  @observable public scholarship = null;
  @observable public empty = false;
  @observable public admissions = null
  @observable public admissionKey = null
  @observable public data = null;
  @observable public loading = false;
  @observable public academic = null;
  @observable public process = false;
  @observable public term = null;
  @observable public student = null;
  @observable public studentTerm = null;
  @observable public creditAttempt = null;
  @observable public creditEarned = null;
  @observable public totalPoint = 0;
  @observable public totalCredit = 0;
  @observable public totalGPA = 0;
  @observable public selectedAdmission = null;
  @observable public selectedAcademicYear = null;
  @observable public admissionDate = null;
  @observable public filterType = null;
  @observable public invoiceData = [];
  @observable public invoiceUnpaid = [];
  @observable public scholarshipdata = null;
  @observable public scholarship_penalty = null;
  @observable public creditNote = null;
  @observable public course = null;
  @observable public schedules = null;
  @observable public schedulesBatch = null;
  @observable public emptyCourse = false;
  @observable public invoices = [];

  @observable public prepaid = null;
  @observable public installment = null;
  @observable public payPageKey = null;
  @observable public studentPrepaid = [];
  @observable public studentTesting = null;
  @observable public studentAdmission = null;

  @observable studentAdmissions: any[] = [];

  @observable
  public transfer = null;

  constructor
    (
      private db: AdministratorService,
      private ds: DataService,
      private afs: AngularFirestore,
      private auth: AuthStore
    ) { }

  @observable loadingInvoice: boolean = true;
  @observable fetchTestingInvoiceRef: any = null;
  @action
  fetchTestingInvoice(studentKey) {
    this.loadingInvoice = true;
    this.fetchTestingInvoiceRef = this.ds.studentInvoiceRef(studentKey)
      .valueChanges()
      .subscribe(docs => {
        this.invoices = docs;
        this.empty = docs.length == 0;
        this.loadingInvoice = false;
      });
  }

  @observable fetchNationalityToArrayRef: any = null;
  @action
  fetchNationalityToArray(callback) {
    this.loading = true;
    this.fetchNationalityToArrayRef = this.ds
      .nationalityArrayRef()
      .valueChanges()
      .subscribe(docs => {
        this.loading = false;
        callback(docs);
      });
  }

  @observable fetchStudentAdmissionRef: any = null;
  @action
  fetchStudentAdmission(studentKey: string) {
    this.loading = true;
    this.fetchStudentAdmissionRef = this.ds.studentAdmissionByStudentRef(studentKey)
      .valueChanges()
      .subscribe(docs => {
        this.studentAdmissions = MappingService.orderByDesc(docs, "academicYear.startDate");
        this.loading = false;
      })
  }

  @action
  fetchStudentByAdmission(key, callback) {
    this.loading = true;
    this.ds.studentAdmissionDBRef(key).valueChanges().subscribe(docs => {
      if (docs.length > 0) {
        this.studentAdmission = docs[0];
      } else this.studentAdmission = null;
      this.loading = false;

      callback(this.studentAdmission)
    })
  }

  @action
  async fetchOtherServiceFee() {
    const docs = await this.ds.otherServiceFeeRef().get().toPromise();
    return MappingService.orderBy(pushToArray(docs), "order");
  }

  @action
  async resetStudentTesting(testing: any, user: any, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const sysData = await this.ds.sysSetting().get().toPromise();
    const sysDoc = MappingService.pushToObject(sysData);

    const { programLevel, subject_type, key } = testing
    const { program } = programLevel
    const { test_KGE, test_IEP } = sysDoc

    let subjectType = subject_type
    if (program.key === test_KGE.key || program.key == test_IEP.key) {
      subjectType = SUBJECT_DATA.khmer;
    }

    const testingRef = this.ds.testingFireRef().doc(key);
    const testingQuestions = MappingService.pushToArray(await this.ds.testingDBRef().doc(key).collection("placementTest").get().toPromise())
    if (testingQuestions && testingQuestions.length > 0) {
      testingQuestions.map((m) => {
        batch.delete(testingRef.collection("placementTest").doc(m.key))
      })
    }

    batch.update(testingRef, {
      used: false,
      subject_type: subjectType
    })

    batch.commit().then(() => {
      this.process = false;
      callback(true, null)
    }).catch(error => {
      this.process = false;
      callback(false, error)
    })
  }

  @action
  async setStudentID(studentId, student: any, user: any, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const sysData = await this.ds.sysSetting().get().toPromise();
    const sysDoc = MappingService.pushToObject(sysData);

    const studentRef = this.ds.studentFireRef();
    const studentAccountRef = this.ds.studentAccountFireRef();
    const settingRef = this.ds.settingFireStoreFire();

    const { puc_id } = student
    //===== New ID
    if (!puc_id) {
      const pucID = studentId ? `${studentId}` : ConvertService.generate_puc_id(sysDoc);
      const emailStudent = pucID + "@gmail.com";
      student.puc_id = pucID;
      student.email = emailStudent;
      const studentAccount: IStudentAccount = {
        key: student.key,
        create_date: new Date(),
        create_by: MappingService.userObj(user),
        status: recordStatus.active,
        puc_id: pucID,
        email: emailStudent,
        fileUrl: null,
        displayName: student.full_name,
        studentKey: student.key,
        phone: student.mobile_phone,
        token: null,
        pinCode: null,
        student: MappingService.studentObj(student),
      };

      batch.update(studentRef.doc(student.key), {
        puc_id: pucID,
        email: emailStudent,
      })
      batch.set(studentAccountRef.doc(studentAccount.key), studentAccount);

      // NEW ID NUMBER
      if (!studentId) {
        batch.update(settingRef, { puc_id: firebase.firestore.FieldValue.increment(1) });
      }
    }

    batch.commit().then(async () => {

      const studentAccount = await this.ds.studentDocument(student.key).get().toPromise();
      const studentData = MappingService.pushToObject(studentAccount);
      this.process = false;
      callback(true, studentData)
    }).catch(error => {
      this.process = false;
      callback(false, error)
    })
  }

  @action
  fetchStudentSchedule(termKey, studentKey) {
    this.loading = true;
    this.course = [];
    this.ds.studentCurrentScheduleRef(termKey, studentKey).valueChanges().subscribe(docs => {
      this.course = docs;
      this.emptyCourse = docs.length === 0;
      this.loading = false;
    })
  }

  @action
  fetchEnglishStudentSchedule(studentKey: string, term: any, admission: any) {
    this.loading = true;
    const { institute, key } = term;
    this.schedules = [];
    this.ds.studentDoc(studentKey).valueChanges().subscribe(doc => {
      const studentData = doc;
      const batch = studentData[institute.key];
      if (batch) {
        this.ds.batchLevelRef().doc(batch.key).collection("schedules", ref => ref
          .where("term.key", "==", key)).valueChanges().subscribe(docs => {
            if (docs && docs.length > 0) {
              this.schedulesBatch = docs[0];

              const termAdmission = admission.term;
              const termSchedule = this.schedulesBatch.term;
              if (termAdmission.startDateKey <= termSchedule.startDateKey) {
                this.schedules = docs;
              }
            }
            this.loading = false;
          })
      } else {
        this.schedules = [];
        this.loading = false;
      }
    })
  }

  @action
  fetchScheduleDocument(termKey, scheduleKey) {
    return this.db.academicTermDocRef().doc(termKey).collection("schedules").doc(scheduleKey);
  }

  @action
  fetchInvoiceData(key) {
    this.process = true;
    this.invoiceData = [];
    this.invoiceUnpaid = [];
    this.ds.studentInvoiceRef(key).valueChanges().subscribe(docs => {
      if (docs.length > 0) {
        this.invoiceData = docs.filter(m => m.isPaid.key === paymentStatus.paid.key);
        this.invoiceUnpaid = docs.filter(m => !m.isVoid && m.isPaid.key === paymentStatus.unpaid.key);
      }
      this.process = false;
    });
  }

  @action
  fetchScholarshipPenalty(studentkey) {
    this.loading = true;
    this.ds.scholarship_penaltyRef(studentkey).valueChanges().subscribe(docs => {
      this.scholarship_penalty = docs;
      this.loading = false;
    })
  }

  @action
  fetchScholashipData(key) {
    this.process = true;
    this.ds.allscholarshipRef(key).valueChanges().subscribe(docs => {
      this.scholarshipdata = docs;
      this.process = false;
    });
  }
  @action
  hiddenAndShowCourse(studentKey, admissionKey, courseKey, courseStatus, user, callback) {
    this.process = true;
    this.db.transcriptCourseRef(studentKey, admissionKey, courseKey).update({
      status: courseStatus,
      admissionKey: admissionKey,
      studentKey: studentKey,
      update_by: MappingService.userObj(user),
      update_date: new Date(),
    }).then(() => {
      this.process = false;
      callback(true, null)
    }).catch(error => {
      this.process = false;
      callback(false, error)
    })
  }

  @action
  deleteAdmission(key, callback) {
    this.process = true;
    this.db.admissionRef().doc(key).update({
      status: status[2]
    }).then(() => {
      this.process = false;
      callback(true, null)
    }).catch(error => {
      this.process = false;
      callback(false, error)
    })
  }

  @action
  fetchAdmission(studentKey, callback) {
    this.loading = true;
    this.db.fetchAdmission(studentKey).valueChanges().subscribe(doc => {
      const list = doc.filter(m => m.major);
      const docs = MappingService.orderByDesc(list, 'program.order');
      this.admissions = docs;
      this.selectedAdmission = docs.length > 0 ? docs[0] : null;
      this.loading = false;
      callback(docs);
    })
  }

  @action
  fetchUnpaidInvoice(key) {
    this.process = true;
    this.ds.studentInvoiceRef(key).valueChanges().subscribe(docs => {
      if (docs.length > 0) {
        this.invoices = docs.filter(m => !m.isVoid && m.isPaid.key === paymentStatus.unpaid.key);
      }
      this.process = false;
    });
  }

  @action
  fetchSelectedAdmission(studentKey, admissionKey, callback) {
    this.loading = true;
    this.db.fetchAdmission(studentKey).valueChanges().subscribe(docs => {
      this.admissions = docs;
      let aKey = admissionKey;
      if (!admissionKey) aKey = docs[0].key;
      const admission = docs.filter(m => m.key === aKey)[0];
      this.selectedAdmission = docs[0];
      if (admission.length > 0) {
        this.selectedAdmission = admission[0]
      }
      this.loading = false;
      callback(docs);
    })
  }

  @action
  fetchStudentTransfer(studentKey, callback) {
    this.process = true;
    this.ds.studentTransfer(studentKey).valueChanges().subscribe(docs => {
      this.process = false;
      const data = MappingService.orderByDesc(docs, "page_key");
      callback(data);
    })
  }

  @action
  fetchAdmissionByKey(admissionKey, callback) {
    this.loading = true;
    this.db.admissionRef().doc(admissionKey).valueChanges().subscribe(doc => {
      this.admissions = doc;
      this.loading = false;
      callback(doc);
    })
  }

  @action
  resoleProgram(studentCode, studentKey) {
    this.db.transcriptStudentRef(studentCode).valueChanges().subscribe(snapshots => {
      const subjects = [];
      snapshots.forEach(r => {
        const courseNum = ConvertService.toNumber(r.courseCode.match(/\d+/)[0]);
        subjects.push({
          courseId: courseNum,
          ...r
        })
      })
      this.db.fetchAdmission(studentKey).valueChanges().subscribe(docs => {
      })
    })
  }

  @action
  fetchCourseInvalidGrade(studentKey, admissionKey) {
    this.loading = true;
    this.db.transcriptFireRef(studentKey, admissionKey).valueChanges().subscribe(snapshots => {
      const items = snapshots.filter(m => m.isShow && m.status.key === 1 && m.credits_earned === 0);
      const result = MappingService.uniqOnTop(items, "courseCode", "page_key");
      this.data = result;
      const t = MappingService.groupBy(result, "term.key", "term.startDateKey");
      this.studentTerm = t;
      this.empty = result.length === 0;
      this.loading = false;
    })
  }

  @action
  fetchData(schoolKey, field) {
    this.loading = true;
    this.ds.studentRef(schoolKey, field).valueChanges().subscribe(docs => {
      this.empty = docs.length === 0;
      this.data = docs;
      this.loading = false;
    });
  }

  @action
  search(schoolKey, campushKey, field, search) {
    if (search.key) {
      return this.ds.studentSearchRef(schoolKey, campushKey, field, search.puc_id).valueChanges();
    }
    return this.ds.studentSearchRef(schoolKey, campushKey, field, search).valueChanges();
  }

  // @action
  // fetchData(studentKey, admissionKey, status: number) {
  //   this.loading = true;
  //   this.ds.transcriptFireRef(studentKey, admissionKey).valueChanges().subscribe(snapshots => {
  //     let items = snapshots.filter(m => m.isShow && m.isApproval && m.status.key === status && m.courseCode !== 'TRANA07');
  //     let studentTransfer = snapshots.filter(m => m.courseCode === 'TRANA07');
  //     if (studentTransfer.length > 0) {
  //       studentTransfer = MappingService.orderByDesc(studentTransfer, "page_key");
  //       this.transfer = studentTransfer[0];
  //     }
  //     else this.transfer = null;
  //     // items = items.map(m => ({ ...m, cid: ConvertService.numberOnly(m.courseCode) }))
  //     const tempList = items;
  //     const termCourses = [];
  //     items.forEach(m => {
  //       const rows = tempList.filter(i => i.term.key === m.term.key && m.courseCode === i.courseCode);
  //       if (rows.length > 1) {
  //         const rm = rows.filter(m => m.credits_calculator > 0)
  //         if (rm.length > 0) termCourses.push(rm[0])
  //         else termCourses.push(rows[0])
  //       }
  //       else {
  //         termCourses.push(m);
  //       }
  //     })
  //     // const result = MappingService.uniqOnTop(termCourses, "courseName", "term.startDateKey");
  //     // this.data = result;
  //     // if (this.data.length > 0) {
  //     //   const orderData = MappingService.orderBy(this.data, 'term.startDateKey');
  //     //   this.admissionDate = orderData[0].term.startterm;
  //     // }
  //     const result = MappingService.orderBy(termCourses, "term.startDateKey");
  //     this.data = result;

  //     const subjectSEarned = result.filter(m => m.overall_grade !== 'IP' && m.overall_grade !== 'I' && m.overall_grade !== 'W');
  //     this.creditAttempt = MappingService.sumCreditAttempted(result);
  //     const subjectEarned = subjectSEarned;
  //     this.totalCredit = MappingService.sumCreditCalculator(subjectEarned);
  //     this.creditEarned = MappingService.sumCreditEarned(subjectEarned);
  //     const subjectTotalPoint = subjectEarned.map(item => { return { total: item.gradePoint * item.credits_calculator } });
  //     this.totalPoint = MappingService.sumTotalPoint(subjectTotalPoint);
  //     this.totalGPA = this.totalPoint / this.totalCredit;
  //     const t = MappingService.groupBy(result, "term.key", "term.startDateKey");
  //     this.studentTerm = t;
  //     this.empty = result.length === 0;
  //     this.loading = false;
  //   })
  // }

  @action
  saveStudent(studentKey: string, admission: Array<any>, f: any, user, callback) {
    const batch = this.ds.batch();
    this.process = true;
    const studentRef = this.ds.studentFireRef().doc(studentKey);
    const admissionRef = this.ds.admissionFireRef();
    batch.update(studentRef, f);
    admission.forEach(item => {
      batch.update(admissionRef.doc(item.key), f)
    });
    batch.commit().then(() => {
      this.process = false;
      callback(true, null)
    }).catch(error => {
      this.process = false;
      callback(false, error)
    })
  }

  @action
  saveStudentTransfer(studentKey: string, admission: any, item: any, callback) {
    const batch = this.ds.batch();
    this.loading = true;

    const studentTranscriptRef = this.ds.studentTranscriptFire().doc(studentKey).collection("admission").doc(admission.key).collection("courses").doc(item.key);
    const studentTransferRef = this.ds.studentTransferFire().doc(item.key);
    batch.set(studentTranscriptRef, item);
    batch.set(studentTransferRef, item);

    batch.commit().then(() => {
      this.loading = false;
      callback(true, null)
    }).catch(error => {
      this.loading = false;
      callback(false, error)
    })
  }

  @action
  updateEducations(studentKey: string, admissionKey: string, f: any, callback) {
    const batch = this.ds.batch();
    this.process = true;
    const studentRef = this.ds.studentFireRef().doc(studentKey);
    const admissionRef = this.ds.studentAdmissionTranscriptFire(studentKey).doc(admissionKey);
    const studentAdmissionRef = this.ds.studentTranscriptFire().doc(studentKey).collection("admission").doc(admissionKey);
    const majorAdmissionRef = this.ds.admissionFireRef().doc(admissionKey);

    batch.update(studentAdmissionRef, f)
    batch.update(studentRef, f);
    batch.update(majorAdmissionRef, f);
    batch.update(admissionRef, f);

    batch.commit().then(() => {
      this.process = false;
      callback(true, null)
    }).catch(error => {
      this.process = false;
      callback(false, error)
    })
  }

  @action
  studentDoc(any, callback) {
    this.process = true;
    this.ds
      .studentDoc(any)
      .valueChanges()
      .subscribe(docs => {
        this.process = false;
        callback(docs);
      });
  }

  @action
  fetchTerm() {
    this.process = true;
    this.ds
      .termRef()
      .valueChanges()
      .subscribe(docs => {
        this.term = docs;
        this.process = false;
      });
  }

  // @action
  // fetchStudent(key: string, callback) {
  //   this.process = true;
  //   this.ds
  //     .studentDoc(key)
  //     .valueChanges()
  //     .subscribe(doc => {
  //       this.student = doc;
  //       const { creditRef } = doc;
  //       this.creditNote = ConvertService.toNull(creditRef);
  //       this.process = false;
  //       callback(doc);
  //     });
  // }

  @action
  async fetchAcademicYear() {
    let selectedAcademicYear = null;
    const envDoc: any = await this.ds.academicRef().get().toPromise();
    const envData = MappingService.pushToObject(envDoc);
    if (this.selectedAdmission) {
      const { program_academic } = this.selectedAdmission;
      if (program_academic && program_academic.program.programOption.key === 1)
        selectedAcademicYear = envData.year;
      else
        selectedAcademicYear = envData.term;
    }
    return selectedAcademicYear;
  }

  @action
  clearStudentStore() {
    this.student = null;
    this.selectedAdmission = null;
    this.admissions = [];
    this.selectedAcademicYear = null;
  }

  @action
  async fetchStudent(studentKey: string, admissionKey: string, callback?: any) {
    this.clearStudentStore();
    this.loading = true;
    const studentDoc = await this.ds.studentDocument(studentKey).get().toPromise();
    const admissionDoc = await this.ds.admissionRef().doc(admissionKey).get().toPromise();
    const admissionList = await this.ds.studentAllAdmissionRef(studentKey).get().toPromise();
    const studentData = MappingService.pushToObject(studentDoc);
    this.admissions = MappingService.orderByDesc(MappingService.pushToArray(admissionList), "academicYear.startDate");
    this.selectedAdmission = MappingService.pushToObject(admissionDoc)
    this.student = studentData;
    this.selectedAcademicYear = await this.fetchAcademicYear();
    const { prepaid, installment } = studentData;
    this.installment = ConvertService.toNumber(installment);
    this.prepaid = ConvertService.toNumber(prepaid);
    this.loading = false;
    if (callback) callback(studentData)
  }

  @observable fetchScholarshipDataRef: any = null;
  @action
  fetchScholarshipData(studentKey: string) {
    this.loading = true;
    this.fetchScholarshipDataRef = this.ds.scholarshipDBByStudentRef(studentKey)
      .valueChanges()
      .subscribe(doc => {
        this.scholarship = MappingService.orderByDesc(doc, "page_key");
        this.empty = doc.length === 0;
        this.loading = false;
      });
  }

  @action
  fetchStudentTest(testingKey, studentKey) {
    this.loading = true;
    if (testingKey) {
      this.ds.testingStudent(testingKey).valueChanges().subscribe(doc => {
        this.studentTesting = doc;
        this.loading = false;
      })
    }
    else {
      this.ds.studentTestRef(studentKey).valueChanges().subscribe((docs: any) => {
        this.studentTesting = docs.length > 0 ? docs[0] : null;
        this.loading = false;
      })
    }

  }

  @action
  fetchFaculty(callback) {
    this.process = true;
    this.db
      .facultiesDocs()
      .valueChanges()
      .subscribe(docs => {
        callback(docs);
        this.process = false;
      });
  }

  @action
  fetchMajor(facultyKey: string, callback) {
    this.process = true;
    this.db
      .majorDocs(facultyKey)
      .valueChanges()
      .subscribe(docs => {
        callback(docs);
        this.process = false;
      });
  }

  @action
  fetchCountry(callback) {
    this.process = true;
    this.db.countryRef()
      .valueChanges()
      .subscribe(docs => {
        callback(docs);
        this.process = false;
      });
  }

  @action
  fetchProvince(callback) {
    this.process = true;
    this.db.provinceRef()
      .valueChanges()
      .subscribe(docs => {
        callback(docs);
        this.process = false;
      });
  }

  @action
  fetchUniversity(callback) {
    this.process = true;
    this.db.universitiesRef()
      .valueChanges()
      .subscribe(docs => {
        callback(docs);
        this.process = false;
      });
  }

  @action
  fetchNationality(callback) {
    this.process = true;
    this.db.nationalityRef()
      .valueChanges()
      .subscribe(docs => {
        this.process = false;
        callback(docs);
      });
  }

  @action
  fetchScholarship(studentKey, scholarshipKey, callback) {
    this.process = true;
    this.db.scholarshipRef(studentKey, scholarshipKey).valueChanges().subscribe(docs => {
      callback(docs.length === 0 ? null : docs[0]);
      this.process = false;
    })
  }

  // --------------------------------------------------------------------------------------------------------

  lastVisible: any = null;
  currentDate: Date = null;
  infinite: Observable<any[]>;

  @observable public filter = null;
  @observable public orderBy = null;
  @observable public searchText = null;
  @observable public fetching: boolean = false;
  @observable fetchPermissionRecords: Subscription = null;

  infiniteData(data: any) {
    this.infinite = of(data).pipe(distinct((p: any) => p.key));
  }

  @action
  async fetchStudents(search: any, filter: any, orderBy: any) {
    this.orderBy = orderBy;
    this.searchText = search;
    this.filter = filter;
    this.loading = true;
    this.fetching = false;
    this.lastVisible = null;

    this.fetchPermissionRecords && this.fetchPermissionRecords.unsubscribe();
    const ref = this.lazyDataRef(this.lastVisible, search, filter, orderBy);
    this.fetchPermissionRecords = ref.snapshotChanges().subscribe(async (response: any) => {
      this.data = [];
      this.currentDate = this.currentDate || new Date();

      if (!response.length) {
        this.loading = false;
        this.fetching = false;
        return false;
      }

      await Promise.all(response.map(async (item) => {
        const studentData = item.payload.doc.data() as any;

        if (!studentData?.program_academic?.admissionKey) {
          this.data.push({
            ...studentData,
            studentAdmissionData: null,
            admissionAttendanceStatistic: null
          });
          return;
        }

        const studentAdmissionData = pushToObject(await this.afs.collection('academics_major_admission').doc(studentData.program_academic.admissionKey).get().toPromise());
        const admissionAttendanceStatistic = pushToArray(await this.afs.collection('academics_major_admission').doc(studentData.program_academic.admissionKey)
          .collection('admission_attendance_statistic', ref => ref.where('create_date_key', '==', toDateKey(this.currentDate))).get().toPromise());
        this.data.push({ ...studentData, studentAdmissionData, admissionAttendanceStatistic });
        // console.log('admissionAttendanceStatistic', admissionAttendanceStatistic);

      }));


      this.data = this.data.map((f: any, index: number) => ({
        ...f, rowIndex: index + 1
      }));

      this.lastVisible = this.data[this.data.length - 1];
      this.loading = false;
      this.fetching = false;
      this.infiniteData(this.data);
      return true;
    }, (error: any) => {
      console.log('error', error);
      this.loading = false;
    });
  }

  @action
  async fetchMoreStudents() {
    this.fetching = true;

    this.lazyDataRef(this.lastVisible, this.searchText, this.filter, this.orderBy).get().subscribe(async response => {
      if (!response.docs.length) {
        this.loading = false
        this.fetching = false;
        return;
      }

      await Promise.all(response.docs.map(async (item) => {
        const studentData = item.data() as any;
        if (!studentData?.program_academic) return studentData;
        const studentAdmissionData = pushToObject(await this.afs.collection('academics_major_admission').doc(studentData.program_academic.admissionKey).get().toPromise());
        const admissionAttendanceStatistic = pushToArray(await this.afs.collection('academics_major_admission').doc(studentData.program_academic.admissionKey)
          .collection('admission_attendance_statistic', ref => ref.where('create_date_key', '==', toDateKey(this.currentDate))).get().toPromise());
        this.data.push({ ...studentData, studentAdmissionData, admissionAttendanceStatistic });
      }));

      this.data = this.data.map((f: any, index: number) => ({
        ...f, rowIndex: index + 1
      }));

      this.lastVisible = this.data[this.data.length - 1];
      this.fetching = false;
      this.infiniteData(this.data);

      return;
    }, (error: any) => {
      this.fetching = false;
    });
  }

  lazyDataRef(lastVisible: any, search: any, filter: any, orderBy: any) {
    return this.afs.collection("students", ref => {
      let condition = ref.limit(Pages.size);
      if (search && search.search) condition = condition.where('puc_id', '==', search.search);
      else condition = condition.orderBy("puc_id");
      if (lastVisible) condition = condition.startAfter(lastVisible["puc_id"])
      return condition;
    });
  }

  // --

  @action
  async fetchStudents_withFilterPolicyRemark(search: any, filter: any, orderBy: any) {
    this.orderBy = orderBy;
    this.searchText = search;
    this.filter = filter;
    this.loading = true;
    this.fetching = false;
    this.lastVisible = null;

    this.fetchPermissionRecords && this.fetchPermissionRecords.unsubscribe();
    const ref = this.lazyDataRef_withFilterPolicyRemark(this.lastVisible, search, filter, orderBy);
    this.fetchPermissionRecords = ref.snapshotChanges().subscribe(async (response: any) => {
      this.data = [];
      this.infinite = of([]);
      this.currentDate = this.currentDate || new Date();

      if (!response.length) {
        this.loading = false;
        this.fetching = false;
        return false;
      }

      await Promise.all(response.map(async (item) => {
        const data = item.payload.doc.data() as any;
        const studentAdmissionData = pushToObject(await this.afs.collection('academics_major_admission').doc(item.payload.doc.ref.parent.parent.id).get().toPromise());
        if (!studentAdmissionData || !studentAdmissionData.studentKey) return null;
        const studentData = pushToObject(await this.afs.collection('students').doc(studentAdmissionData.studentKey).get().toPromise())
        // const admissionAttendanceStatistic = pushToArray(await this.afs.collection('academics_major_admission').doc(studentData.program_academic.admissionKey)
        //   .collection('admission_attendance_statistic', ref => ref.where('create_date_key', '==', data.create_date_key)).get().toPromise());
        this.data.push({ ...studentData, studentAdmissionData, admissionAttendanceStatistic: [data] });
      }));

      this.data = this.data.filter((item) => item).map((f: any, index: number) => ({
        ...f, rowIndex: index + 1
      }));

      this.lastVisible = response[response.length - 1].payload.doc.data();
      this.loading = false;
      this.fetching = false;
      this.infiniteData(this.data);
      return true;
    }, (error: any) => {
      console.log('error', error);
      this.loading = false;
    });
  }

  @action
  async fetchMoreStudents_withFilterPolicyRemark() {
    this.fetching = true;

    this.lazyDataRef_withFilterPolicyRemark(this.lastVisible, this.searchText, this.filter, this.orderBy).get().subscribe(async response => {
      if (!response.docs.length) {
        this.loading = false
        this.fetching = false;
        return;
      }

      await Promise.all(response.docs.map(async (item) => {
        const data = item.data();
        const studentAdmissionData = pushToObject(await this.afs.collection('academics_major_admission').doc(item.ref.parent.parent.id).get().toPromise());
        const studentData = pushToObject(await this.afs.collection('students').doc(studentAdmissionData.studentKey || studentAdmissionData.student.key).get().toPromise())
        // const admissionAttendanceStatistic = pushToArray(await this.afs.collection('academics_major_admission').doc(studentData.program_academic.admissionKey)
        //   .collection('admission_attendance_statistic', ref => ref.where('create_date_key', '==', data.create_date_key)).get().toPromise());
        this.data.push({ ...studentData, studentAdmissionData, admissionAttendanceStatistic: [data] });
      }));

      this.data = this.data.map((f: any, index: number) => ({
        ...f, rowIndex: index + 1
      }));

      this.lastVisible = response.docs[response.docs.length - 1].data();
      this.fetching = false;
      this.infiniteData(this.data);

      return;
    }, (error: any) => {
      this.fetching = false;
    });
  }

  lazyDataRef_withFilterPolicyRemark(lastVisible: any, search: any, filter: any, orderBy: any) {
    return this.afs.collectionGroup("admission_attendance_statistic", ref => {
      let condition = ref.limit(Pages.size).orderBy("date");
      if (filter && filter.policyRemark) condition = condition.where('remark.key', '==', filter.policyRemark.key);
      if (this.currentDate) condition = condition.where('create_date_key', '==', toDateKey(this.currentDate));
      if (lastVisible) condition = condition.startAfter(lastVisible["date"])
      return condition;
    });
  }

  @action
  async fetchStudentPolicyRemarks() {
    try {
      const policyRemarks = pushToArray(await this.ds.storeRef().collection('policy_remarks').get().toPromise());
      return policyRemarks;
    } catch (error) {
      console.log(error);
    }
  }

  @action
  async fetchStudentShiftPolicyHours() {
    try {
      const policyRemarks = pushToArray(await this.ds.collectionRef('academics_policy_hour').get().toPromise());
      return policyRemarks;
    } catch (error) {
      console.log(error);
    }
  }

  @action
  async addStudentAttendanceMovemeent(studentData: any, policyRemark: any, date: any, callback?: (isSuccess, error) => void) {
    this.process = true;

    const batch = this.ds.batch();
    const { key: studentKey, studentAdmissionData, admissionAttendanceStatistic } = studentData;

    const currentSession = { fromHoursNumber: toHourMM(new Date()), fromHours: toTimeHourMMA(new Date()) }
    const policyHours = pushToArray(await this.ds.schoolFireDocRef().collection("time_and_attendances_policy").where("status.key", "==", 1).get());
    const shiftPolicyHours = pushToArray(await this.ds.collectionRef('academics_policy_hour').get().toPromise());
    const sysConfig = pushToObject(await this.ds.schoolFireDocRef().collection("sys_option").doc("general").get());
    const presentRemark = sysConfig.attendanceP;

    const onConfirmTimeAttendanceDate = date ? date : new Date()
    const dateString = moment(onConfirmTimeAttendanceDate).format("YYYYMMDD");

    const { fromHours } = currentSession;
    const dateTime = moment(`${dateString}-${fromHours}`, "YYYYMMDD-hh:mm:ss A").toDate();
    const createDate = dateTime;

    const currentPolicyHour = policyHours.filter(p => p.fromHoursNumber <= currentSession.fromHoursNumber && p.toHoursNumber >= currentSession.fromHoursNumber)[0];
    const selectedPolicyHour = { fromHour: currentPolicyHour.shift.fromHour_, toHour: currentPolicyHour.shift.toHour_ };
    const presentCheckInInShift_policyHours = policyHours.filter((policyHour) => policyHour.shift.key === currentPolicyHour.shift.key
      && policyHour.remark.key === presentRemark.key && policyHour.type.key === ATTENDANCE_TYPE[0].key);
    const presentCheckInInShift_policyHour = presentCheckInInShift_policyHours.length > 0 ? presentCheckInInShift_policyHours[0] : null;
    const studentTimeAttendances = pushToArray(await this.ds.studentFireRef().doc(studentData.key).collection("time_attendance").where('create_date_key', '==', toDateKey(createDate)).get());

    let timeAttendance = studentTimeAttendances.length > 0 ? studentTimeAttendances[0] : null;
    let remark = attendantRemarkObj(policyRemark);
    let remarkKey = policyRemark.key;

    const { policyHourShift } = admissionAttendanceStatistic[0]
    const selected_shiftPolicyHours = shiftPolicyHours.find(m => m.key === policyHourShift.key)
    if (!timeAttendance) {
      const studentKey = studentData.key;
      const timeAttendanceKey = this.ds.createId();
      const studentTimeAttendance = this.ds.studentFireRef().doc(studentKey).collection("time_attendance").doc(timeAttendanceKey);
      const storeTimeAttendance = this.ds.schoolFireDocRef().collection("time_attendance").doc(timeAttendanceKey);

      remark = attendantRemarkObj(policyRemark);
      remarkKey = policyRemark.key;

      timeAttendance = {
        key: timeAttendanceKey,
        scan_card_key: null,
        create_type: CREATE_TIME_TYPE.administrator,

        create_by: userObj(this.auth.user),
        create_date: createDate,
        create_date_key: toDateKey(createDate),

        studentKey: studentKey,
        student: studentObj(studentData),
        page_key: pageKey(),
        campusKey: studentAdmissionData.campuskey || null,
        schoolKey: studentAdmissionData.schoolKey || null,
        type: HR_USER_TYPES.students,

        policy: attendancePolicyObj(presentCheckInInShift_policyHour),
        policyKey: presentCheckInInShift_policyHour.key,
        policy_hour: selectedPolicyHour,
        policy_type: presentCheckInInShift_policyHour.type,
        remark: remark,
        remarkKey: remarkKey,

        scan_date: createDate,
        scan_date_key: toDateKey(createDate),
        confirm_date: new Date(),
        confirm_by: this.auth.user.key,
        sessionKey: null,
      };

      batch.set(studentTimeAttendance, timeAttendance);
      batch.set(storeTimeAttendance, timeAttendance);

      const attendanceKey = this.ds.createId();
      const studentAttendanceMovementRef_store = this.ds.schoolFireDocRef().collection("student_attendance_movement").doc(attendanceKey);
      const studentAttendanceMovementRef = this.ds.studentFireRef().doc(studentData.key).collection("student_attendance_movement").doc(attendanceKey);

      const sub_selectedPolicyHour = { fromHour: selected_shiftPolicyHours.fromHour_, toHour: selected_shiftPolicyHours.toHour_ };
      const sub_currentSession = { fromHoursNumber: selected_shiftPolicyHours.fromHour_, fromHours: selected_shiftPolicyHours.fromHour };
      const sub_presentCheckInInShift_policyHour = policyHours.find((policyHour) => policyHour.shift.key === selected_shiftPolicyHours.key
        && policyHour.remark.key === presentRemark.key && policyHour.type.key === ATTENDANCE_TYPE[0].key);

      const attendenceMovement: any = {
        key: attendanceKey,
        studentKey: studentKey,
        campusKey: studentAdmissionData.campusKey || null,
        schoolKey: studentAdmissionData.schoolKey || null,
        batchKey: studentAdmissionData.batchKey || null,
        timeAttendanceKey: timeAttendance.key || null,
        status: { key: 1, text: "Active" },
        student: studentObj(studentData),

        create_by: userObj(this.auth.user),
        create_date: createDate,
        create_date_key: toDateKey(createDate),
        create_date_month_key: toMonthKey(createDate),

        admissionKey: studentData.program_academic.admissionKey,
        academicYearKey: studentAdmissionData.academicYearKey,
        programKey: studentAdmissionData.trainingProgramKey,
        levelKey: studentAdmissionData.trainingGradeKey,
        scheduleKey: null,
        schedule_subjectKey: null,
        schedule_subject: null,
        checkIn_date: createDate,
        checkIn_date_key: toDateKey(createDate),

        policy: attendancePolicyObj(sub_presentCheckInInShift_policyHour.policy),
        policyKey: sub_presentCheckInInShift_policyHour.key || "",
        policy_hour: sub_selectedPolicyHour,
        policy_type: sub_presentCheckInInShift_policyHour.type || null,
        remark: remark || null,
        remarkKey: remarkKey || null,

        type: HR_USER_TYPES.students,
        note: timeAttendance && timeAttendance.note || null,

        session: sub_currentSession,
        sessionKey: null,
        confirm_date: new Date(),
        confirm_by: this.auth.user.key,

        prioritizedPageKey: pageKey(),
        prioritizedShift: selected_shiftPolicyHours,
        isPrioritizedMovement: true,
        attendance_registration_init: false,
        attendance_registration_source: ATTENDANCE_MOVEMENT_SOURCE.manual_attendance,
        page_key: pageKey(),
      };

      batch.set(studentAttendanceMovementRef_store, attendenceMovement);
      batch.set(studentAttendanceMovementRef, attendenceMovement);

    } else {
      if (admissionAttendanceStatistic && admissionAttendanceStatistic.length > 0) {

        const attendanceKey = this.ds.createId();
        const studentAttendanceMovementRef_store = this.ds.schoolFireDocRef().collection("student_attendance_movement").doc(attendanceKey);
        const studentAttendanceMovementRef = this.ds.studentFireRef().doc(studentData.key).collection("student_attendance_movement").doc(attendanceKey);

        const sub_selectedPolicyHour = { fromHour: selected_shiftPolicyHours.fromHour_, toHour: selected_shiftPolicyHours.toHour_ };
        const sub_currentSession = { fromHoursNumber: selected_shiftPolicyHours.fromHour_, fromHours: selected_shiftPolicyHours.fromHour };
        const sub_presentCheckInInShift_policyHour = policyHours.find((policyHour) => policyHour.shift.key === selected_shiftPolicyHours.key
          && policyHour.remark.key === presentRemark.key && policyHour.type.key === ATTENDANCE_TYPE[0].key);

        const attendenceMovement: any = {
          key: attendanceKey,
          studentKey: studentKey,
          campusKey: studentAdmissionData.campusKey || null,
          schoolKey: studentAdmissionData.schoolKey || null,
          batchKey: studentAdmissionData.batchKey || null,
          timeAttendanceKey: timeAttendance.key || null,
          status: { key: 1, text: "Active" },
          student: studentObj(studentData),
          page_key: pageKey(),
          create_by: userObj(this.auth.user),
          create_date: createDate,
          create_date_key: toDateKey(createDate),
          create_date_month_key: toMonthKey(createDate),

          admissionKey: studentData.program_academic.admissionKey,
          academicYearKey: studentAdmissionData.academicYearKey,
          programKey: studentAdmissionData.trainingProgramKey,
          levelKey: studentAdmissionData.trainingGradeKey,
          scheduleKey: null,
          schedule_subjectKey: null,
          schedule_subject: null,
          checkIn_date: createDate,
          checkIn_date_key: toDateKey(createDate),

          policy: attendancePolicyObj(sub_presentCheckInInShift_policyHour.policy),
          policyKey: sub_presentCheckInInShift_policyHour.key || "",
          policy_hour: sub_selectedPolicyHour,
          policy_type: sub_presentCheckInInShift_policyHour.type || null,
          remark: remark || null,
          remarkKey: remarkKey || null,

          type: HR_USER_TYPES.students,
          note: timeAttendance && timeAttendance.note || null,

          session: sub_currentSession,
          sessionKey: null,
          confirm_date: new Date(),
          confirm_by: this.auth.user.key,

          isPrioritizedMovement: true,
          prioritizedShift: selected_shiftPolicyHours,
          prioritizedPageKey: pageKey(),
          attendance_registration_init: false,
          attendance_registration_source: ATTENDANCE_MOVEMENT_SOURCE.manual_attendance
        };

        batch.set(studentAttendanceMovementRef_store, attendenceMovement);
        batch.set(studentAttendanceMovementRef, attendenceMovement);
      }


      // shiftPolicyHours.map((item) => {
      //   const attendanceKey = this.ds.createId();
      //   const studentAttendanceMovementRef_store = this.ds.schoolFireDocRef().collection("student_attendance_movement").doc(attendanceKey);
      //   const studentAttendanceMovementRef = this.ds.studentFireRef().doc(studentData.key).collection("student_attendance_movement").doc(attendanceKey);

      //   const sub_selectedPolicyHour = { fromHour: item.fromHour_, toHour: item.toHour_ };
      //   const sub_currentSession = { fromHoursNumber: item.fromHour_, fromHours: item.fromHour };
      //   const sub_presentCheckInInShift_policyHour = policyHours.find((policyHour) => policyHour.shift.key === item.key
      //     && policyHour.remark.key === presentRemark.key && policyHour.type.key === ATTENDANCE_TYPE[0].key);

      //   const attendenceMovement: any = {
      //     key: attendanceKey,
      //     studentKey: studentKey,
      //     campusKey: studentAdmissionData.campusKey || null,
      //     schoolKey: studentAdmissionData.schoolKey || null,
      //     batchKey: studentAdmissionData.batchKey || null,
      //     timeAttendanceKey: timeAttendance.key || null,
      //     status: { key: 1, text: "Active" },
      //     student: studentObj(studentData),

      //     create_by: userObj(this.auth.user),
      //     create_date: createDate,
      //     create_date_key: toDateKey(createDate),
      //     create_date_month_key: toMonthKey(createDate),

      //     admissionKey: studentData.program_academic.admissionKey,
      //     academicYearKey: studentAdmissionData.academicYearKey,
      //     programKey: studentAdmissionData.trainingProgramKey,
      //     levelKey: studentAdmissionData.trainingGradeKey,
      //     scheduleKey: null,
      //     schedule_subjectKey: null,
      //     schedule_subject: null,
      //     checkIn_date: createDate,
      //     checkIn_date_key: toDateKey(createDate),

      //     policy: attendancePolicyObj(sub_presentCheckInInShift_policyHour.policy),
      //     policyKey: sub_presentCheckInInShift_policyHour.key || "",
      //     policy_hour: sub_selectedPolicyHour,
      //     policy_type: sub_presentCheckInInShift_policyHour.type || null,
      //     remark: remark || null,
      //     remarkKey: remarkKey || null,

      //     type: HR_USER_TYPES.students,
      //     note: timeAttendance && timeAttendance.note || null,

      //     session: sub_currentSession,
      //     sessionKey: null,
      //     confirm_date: new Date(),
      //     confirm_by: this.auth.user.key,

      //     isPrioritizedMovement: true,
      //     prioritizedShift: item,
      //     prioritizedPageKey: pageKey(),
      //     attendance_registration_init: false,
      //     attendance_registration_source: ATTENDANCE_MOVEMENT_SOURCE.manual_attendance
      //   };

      //   batch.set(studentAttendanceMovementRef_store, attendenceMovement);
      //   batch.set(studentAttendanceMovementRef, attendenceMovement);
      // });
    }
    this.process = false;


    await batch.commit().then(() => {
      callback(true, null);
      this.process = false;
    }).catch(error => {
      this.process = false;
      callback(false, error);
    });
  }

  getDocumentSize(doc: any): number {
    try {
      const jsonData = JSON.stringify(doc);
      const byteSize = new TextEncoder().encode(jsonData).length;
      return byteSize;
    } catch (error) {
      console.error('Error estimating document size', error);
      return 0;
    }
  }



  async deleteTimeAttendanceMovement() {

    let count = 0;
    const deleteMove = deleteTimeAtt;
    deleteMove.forEach(async element => {
      await this.ds.storeDocRef('ngs').collection("time_attendance").doc(element.key).delete();
      ++count;
      console.log(`Deleted: ${count} / ${deleteMove.length}`);
    });


  }

  async deleteStudentAttendanceMovement() {
    console.log('deleteStudentAttendanceMovement...',);
    //delete student movement
    const deleteMove = deleteData;
    let count = 0;
    deleteMove.forEach(async element => {
      await this.ds.storeDocRef('ngs').collection("student_attendance_movement").doc(element.key).delete();
      ++count;
      console.log(`Deleted: ${count} / ${deleteMove.length}`);
    });
  }


  async deleteSchool_Exam1() {
    console.log('delete School_Exam...');
    this.ds.schoolExamStudentsRef(ref =>
      ref.where('examKey', '==', 'YwVPgrA0ZpOMdjy1kXMw')
        .where('termKey', '!=', 'uid7vzuBbrnvaKoWhcXi')
        .limit(100)
    )
      .get().subscribe(snapshotMovement => {
        let snapshotMovementCount = 0;
        console.log('Size', snapshotMovement.size);

        if (snapshotMovement.size > 0) {
          snapshotMovement.forEach(async (attDoc) => {
            const data = attDoc.data() as any;

            if (data.key &&
              data.examKey === 'YwVPgrA0ZpOMdjy1kXMw' &&
              data.termKey !== 'uid7vzuBbrnvaKoWhcXi') {

              const questionsSnapshot = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("questions").get().toPromise()
              );
              const sections = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("sections").get().toPromise()
              );
              const student_grading_question = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("student_grading_question").get().toPromise()
              );

              questionsSnapshot.forEach(element => {
                this.ds.schoolExamStudents().doc(data.key).collection("questions").doc(element.key).delete();
              });

              sections.forEach(ff => {
                this.ds.schoolExamStudents().doc(data.key).collection("sections").doc(ff.key).delete();
              });

              student_grading_question.forEach(e => {
                this.ds.schoolExamStudents().doc(data.key).collection("student_grading_question").doc(e.key).delete();
              });

              await attDoc.ref.delete();
              ++snapshotMovementCount;
              console.log(`Deleted: ${attDoc.id} ${data.examName} | Date: ${data.created_at} | ${snapshotMovementCount} / ${snapshotMovement.size}`);
            }
          });
        }
      });
  }

  async deleteSchool_Exam2() {
    console.log('delete School_Exam...');
    this.ds.schoolExamStudentsRef(ref =>
      ref.where('examKey', '==', 'P2qp6wUIaWj73bZ3SkSr')
        .limit(100)
    )
      .get().subscribe(snapshotMovement => {
        let snapshotMovementCount = 0;
        console.log('Size', snapshotMovement.size);

        if (snapshotMovement.size > 0) {
          snapshotMovement.forEach(async (attDoc) => {
            const data = attDoc.data() as any;

            if (data.key &&
              data.examKey === 'P2qp6wUIaWj73bZ3SkSr' &&
              data.termKey !== 'uid7vzuBbrnvaKoWhcXi') {

              const questionsSnapshot = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("questions").get().toPromise()
              );
              const sections = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("sections").get().toPromise()
              );
              const student_grading_question = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("student_grading_question").get().toPromise()
              );

              questionsSnapshot.forEach(element => {
                this.ds.schoolExamStudents().doc(data.key).collection("questions").doc(element.key).delete();
              });

              sections.forEach(ff => {
                this.ds.schoolExamStudents().doc(data.key).collection("sections").doc(ff.key).delete();
              });

              student_grading_question.forEach(e => {
                this.ds.schoolExamStudents().doc(data.key).collection("student_grading_question").doc(e.key).delete();
              });

              await attDoc.ref.delete();
              ++snapshotMovementCount;
              console.log(`Deleted: ${attDoc.id} ${data.examName} | Date: ${data.created_at} | ${snapshotMovementCount} / ${snapshotMovement.size}`);
            }
          });
        }
      });
  }

  deleteData = [
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "KpDTe9cj8ACEoxLLakjH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Kpvpzos9P6QaIWR1G4wV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "KsoD8wZRGeaxPonHtZQE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "KwxxtUxQpyPcuHYicRxV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "KxXuRqp4itx75AZrrvYL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "KxgYEFbQfMSZ49INEzzT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "L4xzALTTNSUO7PHoljal_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "L5KlBgcaSPjQlol5ezad_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LCeJ4n1m33nWjikAgaQC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LEngELlHBax4RB1yv7oP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LG7ijUpPNY0nQLplEngT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LHySc5M6IXqq5V8ftpNt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LIlr0U1kopI551uycAF5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LRR4lZkLGNRSIEVf7cNF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LRhsaZqVQEzE078ratPG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LS7GAdYjq0k4nhTjCz7U_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LTgvomCNJY8AxuVxw9xz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LUNrqeV6WV8KK0RXj43T_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LVeGR0NNh9anPpp5Y8el_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LYkq1S1mMfRW0h1du6yZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LZFYYFapwLmwZxsqZFH6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LaJ99hyjd9WCgTJFP9ef_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LgmOrwTvVMSK5o8CXEe6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LmtnOoSTcb6JPBLysITQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ls1hCb6PtkwZRQ2QKxX1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Luivcizp32xdPkV3gz22_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Lvj8QZK7NyBZWqohhEJa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LvnTk0moyPER0rDPx8xn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LwjEPTpZLWkoh7JofBwK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "LxE1sHFee9yuL3S9imch_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ly5AfzkN8QasNpYuAEpK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "M2BFeZRk3csUK3ou65Pt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "M5cdXz2MmQv84DbrFnJo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MAZW1Da4in1gy3BVQHti_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MBEKUxrvXA06rmTerBJD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MBgEDbuE3lI96JiXhExY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MG4XEgyTNAQMGAAWYp3g_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MHbZauI1zIG4Yo0pm8PT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MJGEU3n80q1QtrSb6mag_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MNJvmbNDuIPJN4XMeGil_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MPKqnGWIfMzlLj1RxFd1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MQ0wXR5p6Lqz1ES7yEgX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MQlz2J90vKrZPzRFX1NA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MSOm8LuSXVb2wLoDeXXL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MTLYd5TtcCYLFj5ief7p_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MUib2wUn30lX7ac32gzk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MVQgRYCW9xpZYEYC4TW0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MZALAqGKqmvVzzg2j9ov_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MZLZ5Jb7UWd7xEJjRvVS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "McnhTe59vWOQjNzgpB4p_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MnCkx0wmRw4gcCUm3Bk8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MnjMKCw3VcW7RzGsHhSn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MqEwKYesB2mYnTtCzXXG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MqGeyYLd0qV5oyIzq2An_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Mshi0bolV3dxFgsFGE0B_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MtjBKaGvLA495w6qbn4R_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Mv52P1Y8dAiCPjTeRZj3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "MwRgqE7eUZFAtVDGbCYJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "N3Bh6Ouxmwdl7P0sx3Ix_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "N417qYBzRgtVHrKWjDyA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NB9B1azSqdKCoGn7TUqr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NBPb7i4zlDfFmFG5IBw4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NFlCu4QPvaJxfZIvyw5J_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NL6XNQ8y049aZzVPcPzZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NO4jBwM1KQojRZO0tWJj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NON6czjdB5XAhwNZjSzf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NR1hHvAhCRLYghh1Fyjm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NTA9gQcQYZhCCA2hlvh4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NTAK5DtBufmn9rEAynFn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NTPcG0C3J5eQ4RMdct9g_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NW0oddvhDj20v7qZscqa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NWJ8z0jeRQiNNo5E9beZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NZ51V4QbjrG3bkZBS3y7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NZR4SdG1EDj28d2BZxCm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NZmBsVTcQZV1Kx5wLwfQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NfBaXclT61NYHHG1Rx2a_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Nfm1IfpVWW4btRJxvpzw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Nk0Pp66gdCunqMOBE6yP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Nkc7vFIhm9U6bqOpgm7P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Nkfdx7jNaCkNgDoOacKt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NkpT2kTOm17Ua6D2EOgs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NlTDUQOW5LUhTbAV4Ex3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NmRRjiYPymrhxagg5dIG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Nn1Mg96bgWxleIMK8eQ9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NnzJHl3xvTatcXf52aKc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NoWpKJo5IHh18B2CJH0W_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NpiWvv9Q5QoaMsHyWoot_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NqoUp2vjarfIg8TML4dr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "NwoR6ZrqyfY6LCC9bcWg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OBDEwLaVRkLSQdHasZ09_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OBjk6VmQ4KbOxjlvvpuk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OEUFZb83l4rRcUIjHRhI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OFjM7mlBlgNuqEhk797y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OHFqWOrHvtqk6AeXBsXv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OMFcu2tsXhlkrLyYlqmq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OOWbtUnLrRDbpOAiwMJK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OZKFMHOfYPTvqCwioB6Y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OdGU9JqcIHu2HGuUHwHP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OlGm4r0MS28Ydi8z3ZeK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OmrQilSl4ntes4rDAwTj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "OqIvA9c6EHHi13gMMvLT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "P7533EiOao0X5oHqbEPK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "P96sG9iZk04TK1zvw99F_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PACG86rMKAcTLI3etLD0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PCZLlBN0m6WRawE8g8Pe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PJhw6NU7RgAIjtsDlyJk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PLpd0Ki4gftEUoGheco6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PMREccsR1VkyR9gix8Ag_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PP2yRtaYdz3inFlzS6oK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PQQ4vA0jKX8IkTWLF5Go_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PYNrR5P8iikB7xLJViuk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PYSLHe1Ponuqi4hMUWJO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PcDj3tw7ogGqUDkWci5J_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PfghL0TkwQZ6RrenHVmf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PfzGBRY5NQGQkCeRa9bG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PhUAIi4Es12h56DCu6V5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PhXT9F79tsPbQCgDrnpL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PhexvWyqd9klIouHaAg3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PkM1LcqAOrCqin1tnQ5n_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Pm2dWuVgRGHiPgpbxmom_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PmmLOCD0CGSnYhQLEc55_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PoRTwSl6zpnO8QKtUN5l_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PrJ2leioxSwT1cMmMAlS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "PvpOp0SjzEh7ksjVzBR1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Pwscddex43FWYnijr5x7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Q2bbtcyshwZgMMmutjhg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Q44lO9AfuCqE2YKo1I17_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Q4Yll6DXAXQgWNeVdSDL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Q5MyhuapbHsfuVD9Izdn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Q62kki2nvxf4FxrHdKrd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QB65BEvlahL85gw5DJzY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QBGQIPImyGNGKWLlSqyd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QCsYOkWhiFsIi40wrzrw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QFLt4rfgwgBCj1FSRf5P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QMZHfDSdHEeMzxUTFxMm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QNW5gOoWcm7DGbygtEmk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QRPX6cPXAlovNMd96sAx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QU01wADOLgCAqwpAxTPA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QWYhzl1Hqe3QnIHAlcUM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QZdmUJFKtGjzzDCsuqQm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QaBHbRx3W0pudL6L4ojs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QbC5uUrqXTE8NEDkRDP8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QcOCxeS7fGTxCjlFyFL1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QeU8LrkZiDrw0D3lgDEx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Qi9wyxn1aDl4WAJl3Oa1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QikjwvikDjtRXz2KGqCi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QjBxUlltRQ8k7oA5BYR0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "QoGD0LOFzoEl92Skxjjq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "R0oJW1bWKng8ashyxGbX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "R8ScB9w124sNh7svkhSw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "R9MUdeJCZZs0fU0H56N9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RCTtyP1SrJWbsONBSGPM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RExvGrpzHAT2qFcMHEil_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RGSPUfTcRTMYLZN8ZHea_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RHrNZjnMDIHA18MzLcln_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RHtLWVI21SwF8MQaWvlM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RJj1G4Mlb8se9r49yEAm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RLalwftzRVx1ZiewZhxK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RN6RDGi59diunc1mdZBG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RR2qZR1qeOnRSHSllSCa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RSPG3lW8xbvMuyVcqZdK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RgLyDgrYulH0YREhCXrU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RhglfUPUtAKagt6kvtuj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Rix2hT0ZukVdo7YxcoTj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Rn9XiCp45Ur3PKtdAJll_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RpXMEkUggucdyY0IPgD1Y8VjYyK2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RqoNpBH9TtrZoIfG9oLl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RtP56n5pWeF0CsQCLoEp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RtXjWd9QJBSEkvahtKwa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RtwMaNv1oZmPqtUW2kr0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RvB26icm4VsNzbfJKYJO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RvXapnW46gO6PbcVPHyZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "RwytL5KtaHAj8u3bVShw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Rxgyt7g6HcsJUDnHQQAO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S0gyihfAxUmF9A2Sz3WF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S0xhGE4kx0fSubVWjOWP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S11nVpU4zwFCQiZ3MPNj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S40hclKi0clb85JSSYsa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S7DDS8Yul7VSohcj9upE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S9KjadFEdBUQlNdZhoV9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "S9ab0xs4SeYq3kQZE7gJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SBpj8NuWInfSk44RoY1Y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SC7wQJJVR73qoi0Fex9y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SChgEbnwvaF30O8DDsBx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SGLZe0fFCior8EEsnjUr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SJB55jUcWJ6staJtBsvZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SNJSQH4xEsZPq6dNHbrM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SO2X4zuCGh2bVi8RVBEj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SP8pjEevgQvVrfNRBJxX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SWlcrbSJR5V5Dh5DHhtT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SWld1CI6JbVTD4cCnpGV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SYC6PiKgr1BbasI1maIE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SYdvW2lvKKJ7ESSn827Q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Sb8VdeoOm9uJecGs521Q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Sc0GqvJNyOrpw65I5HsX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SeBIxUhzPJO9HTyxxtOg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SgNGSbPorwZPEM10K5F2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SiIQnviwjFhIDTU9b1pL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SkSxSgXj5jl4m2b1YTSG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Slcvug0GEzQGm3mcAepT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SlnYglov0arhc3XqhoCU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SnNhUmnuzyOYcVqelBPT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SnuAR82bGkbJ28uANBUu_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Sr7DabtvD3QAzCu8UBAx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SrJqtvjRE6vU3zQdjCr1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ssel5FiVuMezrRjjeAx0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "SxrMqjI7BtCOgCMLjfzP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "T7CbpquQI0byngfDkKMW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TAQ7kzbDEUejZApYTGgS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TFOuQic8rwTq2UKGlDFx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TGHaLUEd1Ivuo5aJi1eS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TJzogTrNuPn8x4DNlXcd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TKoZfmnA7Ul4JL8V8Vfj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TWcla0J3T71uRMmJkQt8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TYdYJ8giyq9IRXyejVFW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TajTzqTnevy5DdMd4EE0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TdrZMQScl79IQJjLnzB9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ThIWD6dmXca8vYmlq0F2_YwVPgrA0ZpOMdjy1kXMw_osjBYJ9tGxgmDlStAYj5"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ThNBEstaHfShyFi7PHrd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TjXNqzKo1dH7X83o7JLk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Tl0TbFrlhtgujgUxdvb7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TowTU1NtAJcKu5S7R5ro_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TsT9GUNObkLVHlsFbUYF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ttyp4fvdI0IYutlC3Dvv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TwN71rSXgIjQK1AQUMcA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TyUd8II4aEeikj8idSlq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "TzyNURo8O8LhAHE52EaY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "U2C4R5qqQRgP9KV79x8C_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "U5JIIsyZDALtiaqqRFPs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "U5QTV7qBk3J8ZfUgKfqe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "U6jDBrQwArbsVxEJzAJ9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "U8iMDK7T5oTB9mOcmkov_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UFp3e1aqj07gRVKCVgkT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UKctdipYfZNKZKSQtdWf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UOFXvP1qr4Id2Vz6hLg7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UQjAEA27EvaAiCYU3POK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UUoZOvvmhCruZb79isAY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UVTwRtdMl3SPYAtUYTVb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UWgMwo0PiAgi1VrHjkE9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UXmokttMgLR3YkmI9Sst_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UYJIg6iwoasts6tBnLnC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ufz9agju5jpUL4QQ7YqI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UilHa6HQf4UremfugbHX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UjOn98VvEZ5JRMwqdymA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UjztLfxJfMZBzqasnMGh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UkMDSFp8rmlc9Qv3MPWr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ukcu78kkycpjWRl9Idmv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UmOTNAyx8700oTKGvaVI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UtjqcobrY6JJ9gO2bjPh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "UvfHtmLwVuxPOiXMVD2u_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Uz6dKQjhtxBw0rAbDHkc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "V13URE0B7JPAFpR1FaWq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "V1CDszyifJ1gOpR9ZEOq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "V855ogMJz6zgJbvkc5IX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "V9GktJxs6gOuSPzUtdfM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VAdhisdVa7bfI8yyIkMn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VC8CU4H0PO3H7NFLwDHj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VET0UMmRldM8FRgPAzYD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VIyfBtr2BF7GVMVMmJ8t_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VLeOCULQWMV0IigD0i7X_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VTNNUkLkvK9OzR5hQ5Jo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VUxivv9tjQQr5Rfw52nq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VZOclptSNqBSWUPbccjy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VaJD0EiYKKMgnZGo3b50_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VbejCsWbLj3gPfHaXyJG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VcEjGOAMcO6hVLMndgJR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ve6Pd9UBrXfc0oajh36I_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VereTkFe4WFswQMR5t9D_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VhYZWXTyLXwFO7vxVaLF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VjKgMTYKCfkYCgbd3BdA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VpDOQvcgn9O3mES8ZEnO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VqWXJIHJR4vbRLUOefXi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VsaHcuHRBBgP7ed1rl7W_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Vt7Ry5riK20hNu5oe3uA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "VyRvWS9u0q0D4M4PF8UW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "W4OTOJbmAmCcY0anEDJL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "W61GqP9Bf2SOxk8u71nr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "W6UQDXuLHHaKnoie5jy0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "W7ftk2Lo1CGXpBM2wORy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "W9tBeSaaAv9uXtGkORG4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WAIOLEWoAWM26AO2oSmt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WAM0c7G3cpBRX2m5JIxC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WBWeh7jm4Crwlct4MDN7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WBzL3T13gNk64UlvBL5o_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WGmWQrKCBfNGJZOw9VVb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WHiBaEls9x2QqOYhlI8k_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WKe0Ok5xOc19V7uRC0mn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WMFrWR3Ejeogbd6JlNtT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WQBhG4PTPpRcnTzCslz4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WSXtk3NzVYT5jqUEM2vd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WUKxhtECClQXK4yFYNAg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WYCLrrbUhDJ3SCmyUcMc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WcVF3FtulzHlL5f9ryvT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WeMLTITQX5u3cAYe5dCT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WfTm0hMPtb0vQnGMvtX6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WgTEI2quW1IPKbjHIZ9R_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WgYiSXJUDxNW0jVvNbsX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Wgs6NaB8JBe5vmasiwGS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Wm7gRioISHyRXDgt4AIp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WnQHx7GiLWDI2dI3Z0hs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "WnmGgPWUJSh1lltmarw7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "X29DdCy0dzO5xW5IS5rq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "X4kS12q81hlE2JMPNfTS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "X54wYWkfwgUVp4ZA49TR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XAGFKq79Y6XSziYiJJNY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XAYbznDyr5UXb42QfEC8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XAdBsxNghxkgkURnUn9l_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XD5fUtJAz2uWLvpfaXGf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XHsOQgdOGrxdxRrnKao2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XJbtB7SHzPsonIjHmPZW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XO5iJpPrID7QBrcrHNsW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XOB7pANbCYwxhgivbfJ5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XPZiJkG2RLhcMAjZDPP8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XQB84R8ROeuyMTdj8AxU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XZ8x2nCkpXcbA0ghkaNhwp0WWaA3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Xc3THxr6gh7N7hKk1RA5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "XjTiMKTMD2ILRLrbOSTe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Xrkt39BovrMPAbGyPLqS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Y1vgbKoe5GDWYaC5JGev_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Y5o9PL5aNCUsU1eNowey_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Y67NpYxikTPm4MvgLmqr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Y7u55FVSy9uTEycOFOYd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Y8qBjmLQofFn537dbuUZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Y9VBmq6pXyBraip9Z5PB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YCb0oADyzSOrpQKdGb8l_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YD38oty6wABIpkNMei7F_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YEAXoYnxYeRG8NGsPFLj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YFglTJquCxVd6sGefrzs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YGzd7t72hcg2po1gTTSY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YIXkY1qK7X6iizSK4Jpm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YIrphsMAY1g9TkCR0Keg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YKrw6i0y1ubEcFrnVMws_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YPhajLA8LKkiyudo1F52_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YQPMxtDNeFrZzNPbpoKz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YRrGruz60Yygr7KjTJ8V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YSFjxXQMHJLkcf6jzEDy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YTCY2AdYGpDgedN3cH82_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YU5Q4Y9qoQytSFAqtndJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YXBkqLEKdoxrWYQ7zkKe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YcxLsGxOmBObNAfDVIe5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YhN4q4Gw6SnW74WavMZY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YivPMImUSYYXs6jqTyUr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YjLn6SBc5zWJN8S1kebT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YkOPj4dnWqbnr4MvpohH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YmCouKuqSUlVExyd35Ui_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ypfjpwjh2nYTjIPPQbhF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Ysi8OVDFsuGpFb85TZQq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YuXl9poPpWQhMCGxDegM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YvQvIeCg00G0gH0Cckqa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "YxcrqNFaXvdYUXWIbWId_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Yz72eyyi4BILBT5P0Eac_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Z5rZkhOeviyHY7fpHDhJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Z8rOfbBuvRNSQ660IPNP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "Z958yh6yygFcRN9iP8jl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZAF1wMIx8LfEog1dnstl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZB6WMjMK7ldF3iBpMSOJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZDUCRhitSRVSAx6FzI90dQrmlh43_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZIt32Vo9Kr0khrKemmbh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZJzux7OZw4ftIPziV555_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZKMibrUvx2Td6VTbrhBs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZNZRh2CoRgkwZoehe0cp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZOlPFB7t7QKwYLGICfvQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZQAmz6DtyJwCtkWHBRUz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZTEs6cQQ8Vpx0kvqLtvK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZgkoTLaontPOpn2UvYi9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZnrSFoQFictWXuizvH2r_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZpdbJcHzrH6AVnB49ILZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZtiYdQB5HedmDrGdMz8q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZvIaAdmMI30Qp24csx63_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ZyD3dgsGCfuTMwh24XKA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a0aboNXhFUYnf6EK7Rwa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a21KP7Z4SfpJ67oaGFHN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a2xUJhwCk2lKqIdvVKHq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a3H0f8KDJOJEs54dxYu9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a6MKUs26ESR9kwJUDXES_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a6Ppn20rSdZjz5pNuigG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a7IOldpf0jGSwyKCG6Ar_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "a9LOJGWfu2NoBAtqkAFa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aDVH524PuyPQ13UINaaQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aFJ6yQDcecgDYoEFOHud_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aI6pP0wWGiw5KujLKWCa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aL7Q1FYKimQQQRtbiGmx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aLQCzOXSsOzob6lOQa0P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aLvK9dFSo9OLkuQirqyl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aNIZtp2BnWZLecHj1OAl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aO9HOc9G3hRINwI3CZ1V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aS2MwOdPIoirnmakWIPP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "afmkGYrcb0mBaRC3yIKZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "agHCkpX39Fc2wx5UvDPZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ahtfUSyqhFLIMDgV2Q4h_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "aj25w9kAyfm4P6fsDfMC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ak8EDcxoxgnN1mnQfioK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "alfN8eALCH1FVTfy0Av3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "an1iI6MyG0YhmGUo6gWF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "anWeFxuWx8CSrw6pRRWT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "apiiBcjaGbF56Z7SC0i6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "avmEQsHoxm3dvactjKFM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "az4aPtwxfyVXh2sduvBZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "b3fv13Z7dMpQo0elRriJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "b4bnulD6Y6Y18p30NJnm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "b88LjC3sZFGg4H8KGx95_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "b9BngDnEcgVBWjV7CwmT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bCi9mELtI7wBfPxebTdA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bGZReE8aBD5ljG87L7RB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bJHpr3HXCufWe2xYkUXt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bSIcvS1O3NafJslH2nePu2GNeXY2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bWGQheNznxCOwnWCZ8ef_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bXYgZO1rfWgqAzaN7HYK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bY5mu6smJD17HH1YIyIe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bavW7z4LvKxuLXFiXmd3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "be9UFRFnvV1O9NMky8yQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "beP0kIv3eyxj5x9VEDL1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bed1FVdn868xvycWoQJ6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bhcMweTrYvKSO90Zzlk2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "biBJQnQg78DR34dROCXy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bmr1DrgByLAkntnuaRyN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bnL2Xro46GfadmRSYAgY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bsmAenWWKFZrdbFPjj5a_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bugQzKdMiELSjGWLXOIZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "bwILpmlwKIw9NjpU4caP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cBZB521wqtPvV1X37Ho0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cCNgN5dZ1InmTiK1Ic71_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cCRK3e3slLOYftA6F3lx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cO2cAClY8Z6bISKGRbrA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cP0EmHZbd6SBJEessI6r_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cRmJ9StztMPiNxmfneOx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cSSSFyFJVq2x5Oq4TjoE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cXJt57ZSVwMyMOTiVVfL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cYADpMEGm5fCZqN1aHiT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "caGpyAi4BQnvFog43m6C_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cadS7xoIsPNGfDYZhhZF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cduQ1tf6iOYtmGD7Pjni_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "chAEauKsaj687NbbfPti_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ci1rBpt3A4eY1uWzNoMw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ciJfwEvT3qVAtD1UiGw5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cq6IzPwwjZpDCQVBIhZ0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "crr3eFeoIxs0Kos2EfOt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cvKNvy6ojDc9bc0awQoD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cvrB2Nqa3vdgfa5rlC2V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cxNdrpE2wO86Z8Y90iBj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cy1eK00RtB3t5AS2Ug8r_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "cz5sfQPV5AU4gtlaGaYY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "d0WVRTkhrYmLu2NARD4G_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "d5OCyofYn3PqYWHgZD3Y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "d757GXqOYx2UGPY8jcTs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dAC9ROgUKdxUDgZuHdGt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dCNUX1roLsnEmRZXBrHo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dEpX14weNDHu4LDjRjoL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dEqviKhtlJ6QlLoNTxN5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dFm8fbZINP1Zpb083KUj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dGI3IsX2JUxJDeYcGbG1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dGSX5J0CdMNr3JzQL6Ro_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dIZeLlKMy1YjmFPmOBV6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dMJRqNR3f3WGqCjQ9fhD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dPEkC0yrsWOqpsTQiUg1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dPtZrqqOFAiIZ33YIMD0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dQyXVUcyYa1tIAq0ndKf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dTaOwANSSLRCffqdiigs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dUKbJjaCIGkTBpRL3Xal_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dV7zR11SEuH3gVbdDxVR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dVkwiIb4peKEGvynGeyr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dVxUeL4byfkXDLJIonBq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "daE6gqbiKRx1Hv3FujFk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "daQDUmqgnFZkbuIByVCI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ddIKRnQN555xFpolJCq7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dh8Rm32pJaJG3sHOcigs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dmXzaN9P4njij5aZjVl5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "do7YGghMfCiyf7oDj0IN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dpcb89i7sS1OJxBOEHsS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ds1RmHrvWn0n4aZsN8EY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dtw2CcMAqrNlP2MIjqGLzsG8ZZk1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dvEumuQ3ZfMMGrfLMWKl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dwNHvTQaVTSFYiAM8et4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dxPVyUTof2Fik8YtcPCY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "dz4C08OWgAvuRNPcpcUx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "e3RzmzLTH4r4naIilde8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "e4v0WiMCnIhiWZWvQVPh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "e9MAnFiHtYbZksQNdRRN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eCDBqhdSN3sxFxtWftL3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eFO6zCRTwGFnJbAtbx2M_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eJ6kuH8Ulhlxibwp6DvQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eLWJYAKYVoAnJ9F7o2FY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eNexhnjIq8y0XlLVHqoe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ePSRk4uls4lKt4WXZaCM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eR7QxbHiLIMatRSPJ1Fk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eRAUQd7fzCI5GET381Ol_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eSV1hCIrjbRxNGKUYMZW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eSbO9iCG6KdOtTV5n7y1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eTCTMuLUYtsOeXbHsmjt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eU78C4Pqg6ZCnS4LGv7g_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eXgjbG7jcQCpjrqlI25Q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eaVfD8lRt9J2Dx5xHv87_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "eeSF132bDt2ayf9VfDGK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ek3kgUFeU03gsuJ0YfXG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ekfeux0GcpOC1ezPMrPO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "es8CESMV5Yp9hSiAApcd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ewI71o9xtRTBvFqCU2kQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ex3UM8pocAPifKYQxheC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "f4AL9wrsAEfx7H4ZTfYV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "f5PIG4pjAT6MVJFu5ImM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "f6xCgqbxHDmuN142OOus_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "f7STvyp6bUMSpy7j5BgD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "f7qy1aKTYJ0f7ZVuPXdD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "f9cK3rxPpGHE7uGPFraZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fA0CyTimpTFbtK7vcH7H_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fBlFUFwNyVWx9GeyrSHc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fBrDiDcfPPjYryQvMvY9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fGNRFy5KsRzFI216jlQ1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fMk4rHxRYmBKXdtjoz6Q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fORcm1IdDHWmmY5cQr8f_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fPjsO1Pf9kyyvVeMPlqa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fQ7Ng5iRkaCrg6nj0cel_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fRXSoejZcHFtZV9UU8gm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fRyUYwDwHYWjyq7XlnNi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fTlA6iPAURmxW0XEFxzs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fUN6iWh5jSaoyDF1Y1d8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fcHAmO40A7fLFhPo1Ahi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fep0PcBjPJC1mgh7ABaS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fg4W4XMjDCiBVZZNbwWV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "figR92xoizTXDePMqMIx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fpLfFXbAGRO42gsYn7zw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ftb8B08VtHYhOMpRW2GH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fxVtsxkQMHS98xrWQvjg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fy22d6R9IXzRXoZpLsta_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fyGtKJ4YGPK8LT0SyQAM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "fzLxmHAvhDdU6kjUX0rA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g17f4SyAxeKRYdbFJoJ9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g184WkHSavprGJlwIIti_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g1doHOiTcGJ5QEVLIV1r_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g5botW5C9qVSWokV7IFR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g5w6DyRPh6t4dSDhPYno_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g6WShI5KeSG2dTXRPnQ7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "g7eeDnoQ6dciFUepDlbf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gAASGUDyRnXlbvFCFEdi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gAfcsirWYkFMPI4EtNUm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gB1vhjrs1obiFVyPmiqm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gDAKvqeOAxXXL2KvO1pO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gE0Nb3X3shJTmSG6zJQ3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gEgeDI5ee7lU8QkBino0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gIMUWlu7q6ymuASJfrjT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gJlnqfhbLFDwfqLyWgJu_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gQvxVYRvZA2Vqf1w46RT_YwVPgrA0ZpOMdjy1kXMw_osjBYJ9tGxgmDlStAYj5"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gR96QZvyrsJH3k4N57hG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gSISoxb30bVWm9ixpvGj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gVHFtZq0B48dVAJOUax5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gVXSs7JTOEez6yzeaqZn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gVnujh9q1YSj2QdiQULy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gXi4TiOD3dFFVKI2X2P2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gZuif7imGJ5jHw5NaZXx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ga2nNaCaBq2iXW1t51sB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gcwDn9UAQdNhuqJow02D_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "giHJIKbPAhuEEhcDt9Gy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gl6bRA971HmR1lzvNBvQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gnkmRtEJ1bmDZWtodXuU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gqSXo0mQin7mSrWCQhOk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gtkNeGkaHrvobiLFJxao_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gv4i6VrrytqJA2WiqICz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gvkeudCj7HXGSIHSYVBf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gxXzYkyno3TckIREjMVe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "gz8rNda24ecFZfYo8iyj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "h1bS2N8ZlCgVZZpRZbJK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "h36hg9SSnKoRLdZ2Z3oa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "h9KOOK1iCJkTtTtxmqJZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hAh1PKDZ5HXqAAsJj8nw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hB5A9YwBxgn0E19qD3N8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hL9pBSrZrbHWOXfVhpzx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hLxKAqhCUBMfFjdejAsd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hNlfbQcqJ7avlPMLpS61_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hQbbHNrHjkMZSx6O3RO2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hTdIhjphG0NYSpL5b4C3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hW8JRvznKn6sfuejvkgn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hX4uJpqtmQb59LqErqlV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hakpm8S4Er3tQ1v24hgm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "herJDoyUi2Kn0OK2DE9O_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hfIJ0I3f4B2UTPb1LZHc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hjWoKlDpzlSGF3dtJsGJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hq5CC4P99KB9npFk9Vzk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hrUai6m8Yp0K0wI2WtQD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hs1qy881wDlJ0H2XDs4S_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hweWpiQ5KyHiHLEeaCvk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "hxGjEijqjDgbQz9rDTYp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "i07pH341zUIh1ag1MvmN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iBLfkOWlvz9pM19grqwP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iBnPqDKxeU8cg9g1nYBa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iC5MU6n4gelJXAA9TUmz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iCIrNextoVteJQ6AP6Gk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iINUEJ6JZvKCM14B84EV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iIY29SOpX1tV9APdPb0X_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iJHUG1ALf07ss1lZGIRk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iLwKjVivPIH7RwBdtSeY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iO8YwfUD2m6CX0qzHeFh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iOI9qdbJVItCOPfnhjtV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iQfuJWZFDodau8emGjrP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iSL1oCLyOjouEmQCkCNU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iT4rcZg3raPm2jW5DHY5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iTIgtWIB3KXRfTNTt2zk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iTfN1abAl2SN8u5riw83_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iZmIdH7cCz7jnwzJZJYu_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iaVav29oMuSfyerT7jzc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ibht2ReHX6jjcjEwmuV2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "iegLaDaWmqIlYlRDm6bN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ijmb1r9NeTd6N2vHAoPV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "inZhEdjMrF7ipGpcBqVx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ipFCOD2gH7Lct27JpUld_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ipeDBJbk3oUL47BAiSXB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "irSpohdYWbBWCfzNglTD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "irmCc3VZivRC6A3Egz4W_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "isb3o6xmTQ65dvn2HxhU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "isw3tcdaZ5PAGI5UxAAl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "it9qXOctfq9glmfcfaqC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "j3bxR46o7HGJ7TjMRzhF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "j47vPhsylStxiuWVtuv7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "j8WOJD1wSHPkZCHOdT51_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "j9sQw98l5R0DvYbrmIn1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jAPosBnrMvLCmTl2pPTA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jDdvoMUcRNhDevReMkNW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jEC1aAuxaEHrErYBOdbe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jJPguIYxkBFcqf9VdfbJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jN0SIvhgODennnRNznXs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jNalwiFkXpE3SiHqmnAg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jOfIJJ5hUi3oU2jRrmhA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jPDFQcGA3t5oBVFj6p6k_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jPkdLyeIuIFQyBIichwm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jQyBDzlVMNk7Kb3x9sIN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jUqUUhS37NDTS8V3OrFG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jV7ryfGZ0dR7rhT23iDR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jVM1a7ezYKwbDIq5AHKH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jVkSle8fgqVc5twIasQU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jXnijLcU3wyTcVgHVlRP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jY3L8hhfCqLSMwUEKpyL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jYgFX1CVtsqK7iwxE1jb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jaU1EGbE61judE9md6T7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jdSl0Lex8s8Zu0h7282M_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jfGx9lxBnms0vl7Tfcdg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jfiNNJa7lTesJCMzgvNq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jk99vWjA9ULA0TT1Fqo8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jl4JYq5geS5xqz9GEoVi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jmmxE2jBZZUBPCoIMLrc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jsBgJdGBLLvYyWHlhT6A_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jt58hoskgTFptE34NufE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jtQI0aIIwbtlgP6PkSyw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jtegCCggXY4UiTSXMzfI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "juHOy1LUXTDOBBtmAr4y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "jzMW5fwl8oHMyTDPSK5x_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "k7B0Igzn6SQ0MMBrPqBI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kDcpQixv5KaLSVQbtWY1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kDs3TsGctml2QIrJYjFc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kEAooz3IM9rhZmwoGOYz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kMceICB497NFVXsGJYvr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kMvUoIUJmSTlicgi9E8m_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kPk1VfH7vFPHZIndUQ8P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kPngNKdOC4m9XNcVgkJM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kVTbVKpBxKhapNB4X8le_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kb5QrWBtrNubQ6DpLog9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kgqPFQJPEU352QTXhcW5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "khytCtQz4FAqgRYcVMZE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kiG1Ov1f9UejDyDrQr6V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kiPfnI6tln2VnC1EIm0T_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kod96WFtJQsnjzNQKrml_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "koo3mWohIIrtCpxeei8c_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kutIE49xBCPXu53GoNab_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kvQWuASi99K2mghmhr8S_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "kwzQTW8HNlOHe840ZvL1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "l0yxOmv8hqqacultajF0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "l1o0CbVgEe3Bghp0AFls_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lDagmS6OQFv7rxFkH2Ln_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lGyAHREUpQ4pg71hMdZG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lKazYaRwiusqY839pdyy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lKubM8O3ZVYQbeb8BFTS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lORtzZBM4Nw67tSJBv1U_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lR2RBrs4gHZ6EVbc3rKe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lUKzQp8cJ9whQkTrbP4n_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lWJDVlNipaEddBfJQ9ji_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ldxsilE9hVWZvTDnJ7F6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lk5tVbYulQwAjq7yEA9P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ll9VKQlCxyPSDTaVoI5x_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lmVi6FBRDocv0DpS9CSp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lptgqNslXQ8hsqCAFFxC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lqaqmnGIY8l2wkZmmQlp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lvb49dOm8qFLfFyAYj6Y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lw2Z5Ktkly9bNQGViz9d_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lxOYcqpLXb320tMV6tIn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ly8pjZ5rzhP4SR10Fj2P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lypPLRis4gBOg6nyxqPT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "lyrlGCXGJgnReHmsAaeQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "m4b7fDpQlTsN1opBPryG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "m4vPsW5fCQPkiwrD4fgL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "m5SSAoh0syaZ44DwVFH3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "m7DztJHp14ivKrSGo2TE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mAmCxpXT31H5MRtQepeV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mDy82V4hjOpn6v5Bme61_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mLxgd2h5mtCERZ8EESwh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mOKSjRlDSiFOmul6jZGR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mRf9SdAFKzHEemvqTkQL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mSj235O38aVsKnnKEWcA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mTMgW1bfUB9dBgWHIYS9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mVjpYJXW7zkgAtzTI7He_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "marzhE9rNwCt46GGtu6o_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "meBiFKjPSHUxniZtkY7D_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mjCgP2znpBMYLhRAX35S_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mlkvbts6zbfuXaUt45nz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mmCPkxYTNV37IK8rLzWm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mo2c6XydXE9pKmQvdf6s_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mo4AZJkKYrpZfK6pK0kG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mofPQJViHEUfMTAAdckgnitrYtt2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "msUVS40tltysHrbrXaVC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mu8sjbp0wpLpfsOhmJt1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "mvKNv7P2C09H20rzr7Mj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "n0acvQkMRpz9d7rxEZfk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "n3t5OrDXcxiwlExETe7Q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nFsjS5BU32XN7uQVKWg4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nNFkGpBrEWV1daAZkPA2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nQHMSc14DehPv0BfWkCH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nQg1HtMYauQnOEu3bK3b_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nVZpF31eLzR7QZgwap4j_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nYpUFmnlNKuGpHceMzTE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ncLrY5uYH6o1yeoB1RAo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nfJ3BWOZYQfRfhK8wJkc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nkCB3ARARjN7pcHj97jL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nl7kXJWlHe1PIHbtDQKg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nlMO5bAtZj5aCnbC8M9V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nn0Y0JfCAtZQ8eROc1KX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "noA8U4llSyqeAN6UX5SC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "noQGGLqff7Dw7WB5JGm1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nrkZ0bEaf25K0DtdfaC1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ns5cNCEXunYq8X8gelo5_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nv45u6e2rvIR1u6xGOeI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nw4yCN8O6RRdM24cdenb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "nxTXMw7ZsIUSJMvG3WzN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "o4YvtN2WZ4MeWsXjcr92_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "o4raRhVM0bHWQwhPJLbZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "o8aG51lWRHxI0GqNe1Q0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oCO56RPDNGjgeGvH2Yx8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oHGguBENBQPKdBeRGZHh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oIbxmzTwgIcIbsiZfUct_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oMc5Y8p5HsxYFy6C4VRI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oRkotByt0bZvq1f85pqO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oW5ioMTeAcLhx12DESvR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ocFugNjeVvH26c25Fes1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "og3WxWwEXm9w81fTkJ7Z_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ojmWjOe9QpxwD7FajvGQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "olQa7CYB8oJs5tZewtXO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ooGrBtwC00zOjzoeZXIy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "otDEotfXJgwWa2RBsVkC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "oticjXUzT4gYUKLpuqCW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ouhBdvXQBLFv5TRP68vB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ow8sI7ukOJ2IvERx7nHO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "ozjl6zeMTPGHc5jsdTKI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p1UAAN7r2fIjvLWea85x_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p2LNw7JEaTaGDDODRtXp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p2LtTalPiyeydxzQfCJy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p2wy7auiUkeSjs8hILP2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p37Q6rKKtbJvZkzejY8b_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p73CKVtW8kQpnmjZMcsO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "p7F39kRnhqwrcES0D8bh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pA5wocKUMp3Oxnu4zXMq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pAuXECmjmjXh73mzT8wQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pB3PfmMX1nNmjPL3Dumj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pBgfZi1WO6q0xmEkkx1K_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pJeg30jvqhvzShzZXOuU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pKOKUo4ugn3bfp2seE2O_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pL5srYyx9BeSim0fKSmh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pMrE4qP6JHNFtjSWL4PJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pNKvvB59vRHQpp9jxQLP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pOVrHnN04abjsvmTKL1U_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pR0Thh6xM0LxCLlwRQDb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pRLaSQdH9HxdNHquPY5P_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pT12klBacZHqEg0Rwj2l_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pTcybBazcIdcfutU0YwE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pXhCwvcgfzzTWWX9yyrF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pY07HCITMdllxoZgMPmd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pYQdDuqENRVJHY3Gi73h_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pZ9JToVfijGU31yXQZQU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pcMYhH5S8TcRBjS8JnYE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pdNVYUl4trdhzRXkImYA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pflon1ySqIirj4Qnzskf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pgKbjnVc1LzU4OXw0tNN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "piFkjlvEKFDKQqQv8SZ0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pmBLdbHy7Jiq53LWuZjF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "poEiiPtFvIXup64MAFAA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pqmhwfoWYgqoDd8JeDbS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pqtqxBSUkauYWB6FfZQ7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "prbOPcYdH4283Rq8ZyMz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "psWO6Otsq4fouqGSnu5q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pvuMGMSXp8pD0WLOhlT9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pwKNDp3JXZty74G2N52f_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "py0nSXoEUjZoyswoCGgC_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "py9oOalc32EZCo9iKhNn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "pyLFsHsxp4WvJ1vk5DgE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "q1vnMlmh6jl18pGBQtdB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "q26QFeVmjEIX6JPpRspB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "q3m68EzauTE86bON3EJf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "q5CjQGZoAZA7hFwUNSBJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qAVUjKtkpLRhxJWAxCxo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qAX2XIwGsHp4aTVCzskD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qAs9kTmgI2MsUWPgqb58_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qK3QdHk4NztcWOhKtOnP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qOU2jie1gsQ419mwJWkI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qXTn3WW8heScHynFLUD8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qeC2gyMlWt8iVZ1iAl6s_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qiSrUqze3JiV07VpAKDo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qm9jLKUGayPaV8XEKS8g_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qo0fSPGfNHXuJ0D1vECq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qtBL1vuw99srQAC1P2un_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qtirhn7anwcZP992ZQ7c_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qxfWBs1AEWQEdZdq3FRH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "qyZs0gnALAcu1PHvyq4G_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "r1XVwSIxvNm1rtUDVPWb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "r5sSeOoBAQ0IBeo0aVIq_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rBx3496ZcEx3XAwB03yI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rDN9DrnF7N3LT91ZJG8u_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rHmfAf4LuDbcI1TRuFc4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rKHZen67X9KY7OVcguTS_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rKckLBi7MReHICBtX59q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rLXXO88h2oeEas7yijsV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rNvWJ1ganIESnPH1ZHdH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rQ15CJJ5SpiE3rGB3hXi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rS12GJb1IHopJtEtLq6M_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rSdSHs8EcrIKX4NUTAKz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rVuYcj9GZZ9xRZsWA514_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rWyytS7NiiUC5yuUc8py_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rZSDWdMqS4Fd68VknQ3K_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rc5MUCUGcS0pWgPsUYGI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "reDTRiTdkpNfXRu4qQnw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "reZiLRZZ3CCMoYFB86ZD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rn4euQCnNTzjHn2HoIDF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rp94lm9tTCooQgQy2JUz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rpkWkwJI1GS69MlN6r7T_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rq1mZ59OCVKGpKVgY2Sv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rsxbe623Q0FlxPupaxUs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rt4NUreeTbnF3mWySJBR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "rvBQcfYRABPn9NqRKFt8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "s43LF0urNybLADcorPuz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "s6N0SGtIuEDNnXSlhWHO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sArasGQTzmpj6SHKbJDx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sFWN3bk6JxFbeLfOn2g4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sIEoyuvWVOWEoTjwkGfE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sN5w9oROnOZOnPimhGJM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sRPFulJG7WeLA2jOmnXt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sSLD9ZAy1rWntpBYaoBg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sTITvCdkC2gibrBlrBCm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sTZDk7R3wKZ1YsHl7pGv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sWNNAkKBuJFLS2zf3oW3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sX3FEkJ3jXLskCJM2a1I_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sXPdvFHKAlk0eEaSN4bX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sXZ6g6YMPkCLuj6ZhQXN_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sZxJnFfRgzKlWtuZeCvb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sgclF9cIxFW8aUcGIZGV_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "shJ1ber3F0UzZknCZG6a_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "shsmlcMx6CYXfLpOX2i6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sjcZyqarTuNUagQXJGm9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "skRMC9OuB3f1pe9ucYKY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "skXFS5SRhxFWqONUz0te_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "skrWqtFKsxPliI85dsCe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "slr0ks0RwHzaIaBsIyiv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "snbd1uLSrcmytazk0Om8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "soXrjQWtXRDyoyVGjk52_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "spYQr56lRNMMOBxKWpax_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sqFOBkaKkH4TkX2NfypG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sqpmDTcHrbfdgSHMPjzt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "suWVYnw234Fv8x7y3PCA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "svgIeO9jGgNCg9XdVdcR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "swpJ8bH0w0vk6z6pngMi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "sxyJgDoAe1TLOwfBqREe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "t1VtMmMm99ypbqDrsqP9_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "t2x0nUHP9i964KfYC1Tp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tB8b5tcHZXFWh6ymH6ZP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tByK3T0x6vrRyQXvpLiE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tFepx75kBXfFHUYttdea_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tGZ4Br5mC1gvi8D85sXW_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tHrFg6Trp9onSBeSSxmI_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tJQyqXRuseE94XxoW1Jo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tKT3bABUUggyciLuQpVZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tO887mxi651WVLim3nbF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tONfJDzy9xFmuW5VmOhE_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tSC5jIlrkbCgBhum9Dsf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tZ75Kjoz03x6qBIyJTfe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tbQHX0xli5hn3MrcfmMB_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "te0PyYc7SsHjq9NHNsg7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tgZhKrii7q6AOQzkKhgY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "to2TIvhHnAleh1c8Xs7G_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tpja1QJW4f4OI6Q981lc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "tsz8RAJJ8oit8DVMi9K2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "txciJrWIOje485wmMaMd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "u1F9j0iWPdfaI1K9Jo1f_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "u3BDKOmdPhjUgrHMbSdn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "u5fFOEuPF2mx8wM9LifL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uDpUzQy4heOLm0kyJHBi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uMrZIrHw0uvZJdRn6Aj2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uOgKU5PZvYRrGXQyuZ6V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uRanmFJbziduVPRi4Hlb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uTCXwGmqRmazBhsHmei4_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uU3tTEfH1oMs974kXR1y_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uXvdHhrZ0U1VQvX2yvbk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uhS1sdvTQbj8yNTEVDjA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uls6Qr4f3UqYAMiDo7Tl_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uqBA8vpKss1miT9bkrbO_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uqH0ptpRrC8dPvHqXKdU_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "urnnaZgQGPDM8iBdKs6S_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uscXZktXdA7YgSJf60wQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "usfy6vYSDKtSHjjWE9v7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uuAAihbPiM0fip3rwc6C_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uuiNk03QN1CQzHNQypUY_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "uzxWDfNBAg2SFkdH6wrd_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "v1t9U5Y7S2S4QvexB5KT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "v2wQfzL1lgARHx6rzgDo_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "v9YIqYFiW8hr7AkVpksf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vAWx7eJ7piQWEYl7pIJv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vCooooeoBtq0gxJiXNay_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vD4krSma6BuPaS9IAYkh_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vDGqthHda9VZFzllbuUX_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vTjSo7jU74ExSuspSOIy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vYa0X6sAzsEv8jjv0lDv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vabSMgIntMf4HqLiJzVm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vbdIe1iI7yL4kyNTAlWm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vivDAdbvPiPGX3qoyqyt_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vjL7QE7OzImtAwr5zgcs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vnBljunfp77zYpTBIuNJ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vqEqABHY1Nv7j9XLKkAA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vtFWWP8KmvsyCwrit5eQ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vtJ1ug1IMz6kQg3KA0UR_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vtN1V5R8ufNCGS4X19sz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vtvGR1B7nFpUo71irnUc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vuiwVwUUTk72CdUjAlV6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "vz5KRcADLJm8Ws0ID9N3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "w1fQsJlv1hRSq1AMCwkn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "w51kpVXuEwRSBlaJB4lT_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "w60gn9drpSYY6RN3jhwD_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wJ1pMWrjBUMwBVKwU9kw_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wMDDW5B0WOgqP354goWL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wPhrCnF2rgoPJ4hXbx1p_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wQnspV2PmVE9gSnF8LSe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wR3URF1fIPGX0efXFnsu_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wRiiM8GOVfmjE2HZGmTZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wbHjkLDJ7KyYiIRgshwe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wjLcyfBfZfprVzvF3WA1_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wkCqFhyxJ884o7OP338f_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wumNO5P8iUKPmprYhWRe_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wxnpW6XB3LBPES6P7ONv_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wyJfohbIMUqc04F4k8ea_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "wzIpuueZbp3NdF38Aacc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "x4zC9BEUi96YmfhoUtWb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "x7stLvotXpubF8HbrJno_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xAkwu5THWEUuZerMeeZyFyKSrcn2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xDVQNduObGlGGRvLXQYu_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xDlZXslDMvceQYwYTrm3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xGCK9ccV6YVqcXlTumcP_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xGRfdDFZi3641tcRTIhz_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xHS3WKUhLuUxussB6AEn_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xKZ4RsnFIqNVB8gwdqtp_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xKm5B0N1EVkYG3xotG3b_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xWXNS51NbXXwLLOit5Xj_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xZDfaQ6jtvkuoj5h4rli_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xfd841cMAsr0PkmLyiEs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xhRcX1jS5eju1Ixhtw3c_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xkBU3cPQbhFjBbX1jPvc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xv4XUTLWA9X2NfMGjvh0_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "xwMuN05iBQYdqeyBA6hk_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "y0KjUYxOrDVFAKwQNXcs_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "y4DwzNDVj9CO7DUr2uwm_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "y8SxnJe5JPAbmM1IEglg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yAlaieCguALIaPKiR96u_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yChONxslEZEMh4hGSzVr_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yHdEot496qhZXl0Ni4vg_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yJMceKUWsZHXYXTci1je_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yKX8FghLnz88MhWvRvEH_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yLnLlRnJdb59TDaNKgfL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yNA4Z4Zp8GEIZzY5nVc2_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yNJ9MtaJRjGoS4USSBSy_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yRKNIsEKuBGimFKm7SiG_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yTWP3xpH65OeHQIaQIUc_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yYpe0l8RSNJqxwkI7A4Q_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yZBCqoYNuihzqYPK1k8I_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yZGbHVmjTm1jyGovFke3_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yokJGdH91DyILUTozM1D_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yp3jTt9AdgUwAJTMNThf_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yuDZ2P5J7myPqcyT5l2V_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "yx7jNkfteq3zV4Pz4kLi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "z0KY8tx5sKFw8wr9Dux7_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "z2uEW5ed7422QNlAnwDA_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "z3VzFN4cpniP0EZJ28Qx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "z8MrRxXynT2lhxyzMg7s_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zARaTo8t26ckDLTuqSDi_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zBazvgyqjOhKVwj3UU2f_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zCGDI2NXbf3mxZ1HykSF_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zEfOS1473P4wjbUgpfD8_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zJ1jyVTN6HD3mBftu5Lx_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zJsyqFbvkIwwKXrjokoK_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zPLOIJ1suVm8CT9QlZRa_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zQNsGXZOnI0gJmtkNNli_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zQzybCbU0S6n55V5tEnZ_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zR4I5weDkJsN1WibXVJL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zSc52XotK8juYzFjETys_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zbbxD3R3G3ENT85xRMBM_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zc9OYzHLjOjx3HdSPqjL_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zi1t3oRf4Dc8486cGnC6_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    },
    {
      "termKey": "kAIJpcrtFhT3laoszQRM",
      "key": "zwLouZ3kKv2XFIZt3ufb_YwVPgrA0ZpOMdjy1kXMw_IhxNSiBQsTcChZwUdWkO"
    }
  ]

  async deleteSchool_Exam3() {
    console.log('delete School_Exam...', this.deleteData.length);
    let snapshotMovementCount = 0;

    if (this.deleteData.length > 0) {
      for (const attDoc of this.deleteData) {
        if (attDoc.key) {
          const questionsSnapshot = pushToArray(
            await this.ds.schoolExamStudents().doc(attDoc.key).collection("questions").get().toPromise()
          );
          const sections = pushToArray(
            await this.ds.schoolExamStudents().doc(attDoc.key).collection("sections").get().toPromise()
          );
          const student_grading_question = pushToArray(
            await this.ds.schoolExamStudents().doc(attDoc.key).collection("student_grading_question").get().toPromise()
          );

          for (const element of questionsSnapshot) {
            await this.ds.schoolExamStudents().doc(attDoc.key).collection("questions").doc(element.key).delete();
          }

          for (const ff of sections) {
            await this.ds.schoolExamStudents().doc(attDoc.key).collection("sections").doc(ff.key).delete();
          }

          for (const e of student_grading_question) {
            await this.ds.schoolExamStudents().doc(attDoc.key).collection("student_grading_question").doc(e.key).delete();
          }

          await this.ds.schoolExamStudents().doc(attDoc.key).delete();
          ++snapshotMovementCount;
          console.log(`Deleted: ${attDoc.key}    | ${snapshotMovementCount} / ${this.deleteData.length}`);
        }
      }
    }
  }

  async deleteSchool_Exam4() {
    console.log('delete School_Exam...');
    this.ds.schoolExamStudentsRef(ref =>
      ref.where('examKey', '==', 'V2LUmlKxeuAXzov1kwlc').limit(100)
    )
      .get().subscribe(snapshotMovement => {
        let snapshotMovementCount = 0;
        console.log('Size', snapshotMovement.size);

        if (snapshotMovement.size > 0) {
          snapshotMovement.forEach(async (attDoc) => {
            const data = attDoc.data() as any;

            if (data.key &&
              data.examKey === 'V2LUmlKxeuAXzov1kwlc' &&
              data.termKey !== 'uid7vzuBbrnvaKoWhcXi') {

              const questionsSnapshot = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("questions").get().toPromise()
              );
              const sections = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("sections").get().toPromise()
              );
              const student_grading_question = pushToArray(
                await this.ds.schoolExamStudents().doc(data.key).collection("student_grading_question").get().toPromise()
              );

              questionsSnapshot.forEach(element => {
                this.ds.schoolExamStudents().doc(data.key).collection("questions").doc(element.key).delete();
              });

              sections.forEach(ff => {
                this.ds.schoolExamStudents().doc(data.key).collection("sections").doc(ff.key).delete();
              });

              student_grading_question.forEach(e => {
                this.ds.schoolExamStudents().doc(data.key).collection("student_grading_question").doc(e.key).delete();
              });

              await attDoc.ref.delete();
              ++snapshotMovementCount;
              console.log(`Deleted: ${attDoc.id} ${data.examName} | Date: ${data.created_at} | ${snapshotMovementCount} / ${snapshotMovement.size}`);
            }
          });
        }
      });
  }

  async documentSize() {
    console.log('documentSize')
    const snapshot = await this.ds.collection('request_permission_student_movement',
      ref => ref.limit(10)).get().toPromise();
    const data = pushToArray(snapshot);
    data.forEach(async (f, index) => {
      // console.log(f.student.puc_id)
      const sizeInBytes = this.getDocumentSize(f);
      console.log(`Deleted: ${f.key} | Date: ${f.create_date_key} | Size: ${sizeInBytes} bytes | ${index + 1}/${data.length}`);
    });
  }

}
